module.exports = __webpack_public_path__ + "static/media/arrow-right-full.86d11873.svg";